import { FC } from "react";

import TableProjectsList from "../../../components/table/projects/TableProjectsList"

import styles from './projectsList.module.scss'

const ProjectsList: FC = () => {
    return (
        <div className={styles.projectsList}>
            <TableProjectsList />
        </div>
    );
};

export default ProjectsList;
